import { Component, h, Host, Element } from '@stencil/core';
import { checkSlottedContentForInvalidHTML } from '../../../../global/utils/utils';
/**
 * @slot - The content placed in this slot must be one to many agl-ds-radio-button components
 */
export class RadioButtonSetComponent {
  componentWillLoad() {
    checkSlottedContentForInvalidHTML(this.host, ['agl-ds-radio-button-set', 'agl-ds-radio-button']);
  }
  render() {
    return (h(Host, null,
      h("div", { class: "grid-container grid-container-override" },
        h("div", { class: "row" },
          h("slot", null)))));
  }
  static get is() { return "agl-ds-radio-button-set"; }
  static get originalStyleUrls() { return {
    "$": ["radio-button-set.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["radio-button-set.component.css"]
  }; }
  static get elementRef() { return "host"; }
}
